function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'bda968b677ab61ef27d29a78e7408e8b': 'rgb(0, 0, 0)','2b93fbdf27d43547bec8794054c28e00': 'rgb(255, 255, 255)','a57fc812a9521b8c0ede9a2724351a55': 'rgb(249, 247, 241)','2d958a41c9a42192597f5038df0e138c': 'rgb(164, 194, 232)','fdfa02ecf86feac3801254da57c1c9ba': 'rgb(97, 98, 100)','32d635528e3a388abb68b97a6eeedf35': 'rgb(210, 209, 212)','a4995d016a80cf2321cda0ab1a966935': 'rgb(226, 180, 120)','180fd182f9a0742f483619781ccc36c4': 'rgb(247, 187, 177)','65cb59645b852c2394ba3ff8b295e83c': 'rgb(81, 149, 164)','88336b5bb2a1cc21bac7cf33fd451270': 'rgb(215, 198, 178)','d487638b2bb09a2c11ea558c6fd12efa': 'rgb(219, 185, 177)','cd9ce6bd8aa97f11e90da10f671377de': 'rgb(0, 0, 0)','ee9144d62c81b824ac308a456c36a28c': 'rgb(0, 0, 0)','a042dcff08bf1d8636a91419b4fba541': 'rgb(0, 0, 0)','3792f402e08bcf1a7feaa99c9e973861': 'rgb(255, 255, 255)','7d74e2c3ee0b27b4441e5e23f3843535': 'rgb(255, 255, 255)','78dacf133b41e40595d738a38274d226': 'rgb(255, 255, 255)','e7b95b49658278100801c88833a52522': 'rgb(109, 104, 78)','88feb6067c0cfe7830c4e82f57b18a1d': 'rgb(242, 242, 237)','01540f319ff0cf88928c83de23127fbb': 'rgb(180, 83, 38)','1506aeeb8c3a699b1e3c87db03156428': 'rgb(35, 49, 74)','8b823f49ba31caa5cd88e520c2f82bdc': 'rgb(196, 219, 213)','a1234b3161b4fbfdfb96dd576b65bbea': 'rgb(147, 176, 202)','e809578d0b633a6db7de68749308f476': 'rgb(234, 229, 215)','6e9bef130bf9d8973810943453d93cb6': 'rgb(204, 220, 231)','97f014516561ef487ec368d6158eb3f4': 'rgb(222, 227, 231)','6aab9eb8f32e566dfa41cbd48f53c80d': 'rgb(172, 176, 163)','cc32cdaf8b33fbec419a6d9c954028c5': 'rgb(222, 211, 192)','aed72fbad3e65e1b65037e19091bfa74': 'rgb(76, 127, 210)',};

    this.images = {};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
